import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { ANALYTICS_JOIN_FIELDS } from '../../graphql/analytics';

// Fetches the field schema of every selected join for the active entity.
// Returns { joinKey: fields[] }.
export function useJoinFields(entity, joins) {
  const client = useApolloClient();
  const [joinFields, setJoinFields] = useState({});
  const joinsKey = (joins || []).join(',');

  useEffect(() => {
    if (!entity || !joinsKey) {
      setJoinFields({});
      return undefined;
    }
    let cancelled = false;
    const joinList = joinsKey.split(',');
    Promise.all(
      joinList.map((join) =>
        client
          .query({ query: ANALYTICS_JOIN_FIELDS, variables: { entity, join } })
          .then((res) => res.data.analyticsJoinFields)
          .catch(() => [])
      )
    ).then((results) => {
      if (cancelled) return;
      const next = {};
      joinList.forEach((join, i) => {
        next[join] = results[i];
      });
      setJoinFields(next);
    });
    return () => {
      cancelled = true;
    };
  }, [client, entity, joinsKey]);

  return joinFields;
}
